import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SharedComponentsModule } from '../../../../shared-components.module';
import { TakeOffCanvasComponent } from '../../canvas/take-off-canvas.component';
import { DrawingMode } from '../../core/constants';
import { Drawing } from '../../core/drawing';
import { DrawingCanvasEvent } from '../../core/drawingcanvas';
import { TakeOffV2StoresService } from '../../take-off-v2/feat-take-off-v2/domain/apis/take-off-v2.stores';
import { ManualScaleService, ScalePlanSteps } from '../manual-scale/manual-scale.service';

@Component({
    selector: 'app-manual-scale-canvas',
    imports: [SharedComponentsModule],
    templateUrl: './manual-scale-canvas.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManualScaleCanvasComponent {
    readonly #manualScaleService = inject(ManualScaleService);
    readonly #takeOffV2StoresService = inject(TakeOffV2StoresService);

    @ViewChild('scaleTakeOffCanvas') private readonly scaleCanvas?: TakeOffCanvasComponent;

    selectedPlan = toSignal(this.#takeOffV2StoresService.selectedPlan$);
    takeoffScaleConfig = this.#manualScaleService.takeOffConfig;
    readonly drawingMode = DrawingMode;

    $watchScaleStep = toObservable(this.#manualScaleService.scaleStep)
        .pipe(takeUntilDestroyed())
        .subscribe((scaleStep) => {
            if (scaleStep === ScalePlanSteps.DRAW_HORIZONTAL || scaleStep === ScalePlanSteps.DRAW_VERTICAL) {
                if (this.scaleCanvas) this.scaleCanvas.removeDrawings();
            }
        });

    scaleDrawingStart(event: DrawingCanvasEvent) {
        // Ensure only one line at a time when testing scale
        if (this.scaleCanvas?.drawings) {
            for (var i = 0; i < this.scaleCanvas.drawings.length; i++) {
                const d = this.scaleCanvas.drawings[i] as Drawing;
                if (d !== event.args.drawing) this.scaleCanvas.removeDrawing(d);
            }
        }
    }

    scaleDrawingFinish(event: DrawingCanvasEvent) {
        // Validate that the line measurement is correct
        if (!event.args.drawing.measurement && this.scaleCanvas) {
            this.scaleCanvas.removeDrawings();
            return;
        }

        this.#manualScaleService.drawingFinish(event);
    }
}
